import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TaskField } from 'stores/fields';
import { CardNames } from '../api';
import {
  ProjectOverviewAllPhasesCard,
  ProjectOverviewStatusUpdateCard,
  ProjectOverviewTasksAtRiskCard,
  ProjectOverviewBlockedTasksCard,
  ProjectOverviewOverdueTasksCard,
  ProjectOverviewTasksCompletedLateCard,
  ProjectOverviewTasksCompletedCard,
  ProjectOverviewPlannedVsActualCard,
  ProjectOverviewBusinessGoalsCard,
  ProjectOverViewKeyEventsCard,
} from './cards';

export const GridSystemConfig = {
  sm: {
    xxl: 8,
    xl: 12,
    lg: 24,
    md: 24,
    sm: 24,
    xs: 24,
  },
  md: {
    xxl: 16,
    xl: 24,
    lg: 24,
    md: 24,
    sm: 24,
    xs: 24,
  },
  lg: {
    xxl: 24,
    xl: 24,
    lg: 24,
    md: 24,
    sm: 24,
    xs: 24,
  },
  grouped: {
    xxl: 8,
    xl: 24,
    lg: 24,
    md: 24,
    sm: 24,
    xs: 24,
    children: { xxl: 12, xl: 6, lg: 12, md: 12, sm: 12, xs: 12 },
  },
};

interface CardNameMappingPayload {
  [key: string]: {
    title: JSX.Element;
    content: JSX.Element;
  };
}

export const CardNameToComponentMapping = (
  projectId: number,
  taskFields: Record<string, TaskField>,
): CardNameMappingPayload => {
  return {
    [CardNames.AllPhases]: {
      title: <ProjectOverviewAllPhasesCard.Title projectId={projectId} />,
      content: <ProjectOverviewAllPhasesCard.Content projectId={projectId} />,
    },
    [CardNames.StatusUpdates]: {
      title: <ProjectOverviewStatusUpdateCard.Title projectId={projectId} />,
      content: (
        <ProjectOverviewStatusUpdateCard.Content projectId={projectId} />
      ),
    },
    [CardNames.PlannedVsActual]: {
      title: <ProjectOverviewPlannedVsActualCard.Title projectId={projectId} />,
      content: (
        <ProjectOverviewPlannedVsActualCard.Content projectId={projectId} />
      ),
    },
    [CardNames.BusinessGoals]: {
      title: <ProjectOverviewBusinessGoalsCard.Title projectId={projectId} />,
      content: (
        <ProjectOverviewBusinessGoalsCard.Content projectId={projectId} />
      ),
    },
    [CardNames.KeyEventsAndIntervals]: {
      title: <ProjectOverViewKeyEventsCard.Content projectId={projectId} />,
      content: <></>,
    },
    [CardNames.TasksAtRisk]: {
      title: (
        <ProjectOverviewTasksAtRiskCard.Title
          projectId={projectId}
          taskFields={taskFields}
        />
      ),
      content: <ProjectOverviewTasksAtRiskCard.Content projectId={projectId} />,
    },
    [CardNames.BlockedTasks]: {
      title: (
        <ProjectOverviewBlockedTasksCard.Title
          projectId={projectId}
          taskFields={taskFields}
        />
      ),
      content: (
        <ProjectOverviewBlockedTasksCard.Content projectId={projectId} />
      ),
    },
    [CardNames.OverdueTasks]: {
      title: (
        <ProjectOverviewOverdueTasksCard.Title
          projectId={projectId}
          taskFields={taskFields}
        />
      ),
      content: (
        <ProjectOverviewOverdueTasksCard.Content projectId={projectId} />
      ),
    },
    [CardNames.TasksCompletedLate]: {
      title: (
        <ProjectOverviewTasksCompletedLateCard.Title projectId={projectId} />
      ),
      content: (
        <ProjectOverviewTasksCompletedLateCard.Content projectId={projectId} />
      ),
    },
    [CardNames.CountOfTasksAtRisk]: {
      title: <FormattedMessage id="at_risk_tasks" />,
      content: (
        <ProjectOverviewTasksAtRiskCard.Count
          projectId={projectId}
          taskFields={taskFields}
        />
      ),
    },
    [CardNames.CountOfTasksOverdue]: {
      title: <FormattedMessage id="overdue_tasks" />,
      content: (
        <ProjectOverviewOverdueTasksCard.Count
          projectId={projectId}
          taskFields={taskFields}
        />
      ),
    },
    [CardNames.CountOfTasksBlocked]: {
      title: <FormattedMessage id="blocked_tasks" />,
      content: (
        <ProjectOverviewBlockedTasksCard.Count
          projectId={projectId}
          taskFields={taskFields}
        />
      ),
    },
    [CardNames.CountOfTasksCompleted]: {
      title: <FormattedMessage id="completed_tasks" />,
      content: (
        <ProjectOverviewTasksCompletedCard.Count
          projectId={projectId}
          taskFields={taskFields}
        />
      ),
    },
  };
};
